export const SET_MEMBERS = 'SET_MEMBERS';
export const SET_MEMBER = 'SET_MEMBER';
export const ADD_MEMBER = 'ADD_MEMBER';
export const UPDATE_MEMBER = 'UPDATE_MEMBER';
export const REMOVE_MEMBER = 'REMOVE_MEMBER';
export const CLEAR_MEMBER = 'CLEAR_MEMBER';
export const CLEAR_MEMBERS = 'CLEAR_MEMBERS';
